import { render, staticRenderFns } from "./PlacementExamClassroomsTable.vue?vue&type=template&id=01458190"
import script from "./PlacementExamClassroomsTable.vue?vue&type=script&lang=js"
export * from "./PlacementExamClassroomsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports